import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent } from '../ui/card';
import { cardAnimation } from './animations';

export const BenefitCard = ({ icon: Icon, title, description, image, index }) => {
  return (
    <motion.div {...cardAnimation(index)}>
      <Card className="h-full glass-card border-border/50 hover:border-primary/30 transition-all duration-300 group overflow-hidden">
        <div className="relative h-48 overflow-hidden">
          <img
            src={image}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background via-background/50 to-transparent" />
          <div className="absolute bottom-4 left-4 p-3 rounded-xl bg-primary/20 backdrop-blur-sm">
            <Icon className="w-6 h-6 text-primary" />
          </div>
        </div>
        <CardContent className="p-6">
          <h3 className="text-lg font-bold mb-2 text-foreground">{title}</h3>
          <p className="text-sm text-muted-foreground">{description}</p>
        </CardContent>
      </Card>
    </motion.div>
  );
};
